<template>
  <div style="width: 100%; display: flex; flex-direction: row;">
        <el-input 
            @focus="$event.target.select()"
            placeholder="Search..."
            size="small"
            clearable
            @clear="clearSearch"
            style="width: 350px; text-align: left;"
            v-model="search_term" 
            @keyup.enter.native="searchInIt">
            <el-button @click="clearSearch" slot="append" size="small" style="font-size: 22px; top: -1px; position: relative;" icon="el-icon-refresh"> </el-button>
            <el-button @click="show_qr_window=true" slot="append" style="width: 50px" size="small"><img src="https://etacdn.b-cdn.net/qr-scan.png" width="25px" style="top: 3px; position: relative;"/></el-button>
        </el-input>
        <span v-if="searchKeys.length>0 && !hideAvanced" style="top: 5px; left: 10px; position: relative;">
            or
        </span> 
        <a 
            v-if="searchKeys.length>0 && !hideAvanced" @click="show_popup = true" 
            style="top: 5px; left: 18px; position: relative; cursor: pointer; text-decoration: underline">Advanced Search</a>

        <el-dialog
            v-if="show_popup"
            :title="'Advanced Search'"
            :visible.sync="show_popup"
            append-to-body
            width="70%"
            :show-close="show_popup">
                <Advanced 
                    @loadAdvanceSearch="loadAdvanceSearch"
                    :hideSaveOption="hideSaveOption"
                    :searchKeys="searchKeys"/>
        </el-dialog>

        <el-dialog
            v-if="show_qr_window"
            width="70%"
            :visible.sync="show_qr_window"
            append-to-body>
            <qrcode-stream @decode="onDecode" @closed="show_qr_window = false"></qrcode-stream>
        </el-dialog>

  </div>
</template>

<script>
import Advanced from './Advanced'

export default {
    components: {Advanced},
    props: ['searchKeys', 'hideAvanced', 'hideSaveOption'],
    data() {
        return {
            search_term: '', 
            show_popup: false,
            show_qr_window: false
        }
    },
    methods: {
        onDecode($event) {
            this.search_term = $event
            this.show_qr_window = false
            this.searchInIt($event)
        },
        clearSearch() {
            this.search_term = ''
            this.$emit('searchCustom', {search_term: '', search_term_array: []})
        },
        closeModal() {
            this.show_popup = false
        },
        loadAdvanceSearch($event) {
            this.$emit('searchCustom', {search_term: '', search_term_array: $event.search_term_array})
            this.closeModal()
        },
        searchInIt($event) {
            if($event.target !== undefined) {
                $event.target.select()
            }            
            this.$emit('searchCustom', {search_term: this.search_term, search_term_array: []})
        }
    }
}
</script>

<style>

</style>


// WEBPACK FOOTER //
// src/components/SearchField/Index.vue